import { Box, Button, Typography } from '@mui/material'
import { fluentIconFontSizeSx } from '@/theme/sx/fluentIconWrapperSx.js'
import { SectionTitleRowAction } from './SectionTitleRowAction.jsx'
import { sectionTitleRowButtonSx, sectionTitleRowTitleSx } from './sectionTitleRowSx.js'

export default function SectionTitleRow({ Icon, title, actionText, actionFilled = false, onClick, onActionClick }) {
  return (
    <Button type="button" variant="text" onClick={onClick} sx={sectionTitleRowButtonSx}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: '2px' }}>
        <Box sx={{ width: 20, height: 20, display: 'grid', placeItems: 'center' }}>
          {Icon ? (
            <Box component="span" sx={fluentIconFontSizeSx(18, { color: '#424242' })} aria-hidden>
              <Icon />
            </Box>
          ) : null}
        </Box>
        <Typography component="span" sx={sectionTitleRowTitleSx}>
          {title}
        </Typography>
      </Box>
      <SectionTitleRowAction actionText={actionText} actionFilled={actionFilled} onActionClick={onActionClick} />
    </Button>
  )
}
